__webpack_require__.p = "/pgs-widget-gdansk/";